import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductBadge extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  /**
   * Updates the badge on variant change.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadge = event.detail.data.html.querySelector('product-badge');

    if (!newBadge) {
      this.innerHTML = '';
      return;
    }

    morph(this, newBadge, { childrenOnly: true });
  };
}

if (!customElements.get('product-badge')) {
  customElements.define('product-badge', ProductBadge);
}
